import type { FaireProductEntity } from "../../entity_types/product";

export const p_stv9bgn6cz: FaireProductEntity = {
  token: "p_stv9bgn6cz",
  type: "product",
  name: "Apothecary Glass Candle – Pure Beeswax Aromatherapy – 3.2oz",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/835631375af7a031cad5c88275a7f855a070a029e596a4954e0aa2e07d87a502.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfca9be067a3d812980c65c22f2a80b3ede8b398e03916567c9d06db29f903d5.jpeg",
    "https://cdn.faire.com/fastly/4a685da582dbc6bebbe8a0308438e3acd4336ccca86fef645591379cb99c96da.png",
    "https://cdn.faire.com/fastly/2356b47511e8f76c51edacf81d99713635e08e5c15adf88dcc83ddd6b8f49abd.jpeg",
    "https://cdn.faire.com/fastly/c92a37feb604da15d80d7e1cecaac70777c89b398f68b22bf70fdedcbcf1fa1a.jpeg",
    "https://cdn.faire.com/fastly/cad16486ab829ea5c4d8c4957f8c432324c88114fc4abe3f1be9acadc6f07cb1.jpeg",
    "https://cdn.faire.com/fastly/2feb59013a8e4d1f6affd893afa488902a59c03b96e6e170ed3cf3bbea5fb27f.jpeg",
    "https://cdn.faire.com/fastly/b6f57278b53a5d80785678c0f78be6843130ef6c3e9f5b7e2678ae0672c3e2bc.jpeg",
    "https://cdn.faire.com/fastly/99f75600c4dc405cd523459967efa39c4d4d1ee2cb6bb374ff9073bee5a29fc7.jpeg",
    "https://cdn.faire.com/fastly/18e0da7263750c21f87f5b3a141950d338103c4977d32993e4184567648be27f.jpeg",
    "https://cdn.faire.com/fastly/18ee23edcaa95cddac330a26ecb7dd6a409953422d6be4e8303ae59a324fdd15.jpeg",
    "https://cdn.faire.com/fastly/3f8848038307f3b7473e9152279949ea44c3bebd5fbdaa54a21d99146438b153.jpeg",
  ],
  priceDollars: 6.1,
  description:
    "Elevate your space with our Beeswax Aromatherapy Apothecary Glass Candle, handcrafted in small batches using 100% pure beeswax and scented with therapeutic essential oils. This 3.2oz reusable glass jar candle delivers a clean, long-lasting burn for up to 25 hours, releasing the natural, honey-like aroma of beeswax and your choice of pure aromatherapy blends. Perfect for creating a relaxing atmosphere, it’s a sustainable, non-toxic alternative to paraffin candles.\n\nProduct Details:\n\n-Burn Time: 25 hours\n-Wax: 100% Pure Beeswax, naturally aromatic\n-Wick: Cotton, lead-free\n-Jar: Reusable 3.2oz glass\n\nScent Options:\nAwaken (Grapefruite & Spruce)\nBalance (Lavender & Peppermint)\nHarmony (Pure Lavender)\nLove (Geranium & Ylang Ylang)\nMeditation (Cedarwood & Balsam)\nRapture (Patchouli & Cassia)\nRadiance (Tangerine & Ylang Ylang)\nRejuvenation (Sweet Orange & Clove Bud)\nSerenity (Franckincense & Lavender)\n\nUsage: Home Décor, Gifts, Aromatherapy, Dinner Parties, Relaxation, Romantic Settings\n\nNotes: Clean Burning, Non-Toxic, Paraffin Free, Soy Free, Lead Free, Eco-Friendly, Hypoallergenic\n\nLearn more at BigDipperWaxWorks.com.",
  tags: [],
  msrpDollars: 12.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:47.037Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
